import { Relationship } from '../../../../../common';
import { DateOfBirthFieldType } from '../fields';

export const getFieldTypeBasedOnRelation = (relationshipTypeId?: number): DateOfBirthFieldType => {
	switch (relationshipTypeId) {
		case Relationship.Father:
		case Relationship.Mother: {
			return 'parent';
		}
		case Relationship.Son:
		case Relationship.Daughter: {
			return 'child';
		}
		default:
			return 'adult';
	}
};
